module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "prologue",
      "id": "_idContainer",
      "role": "doc-prologue"
    }
  }, [_c('h1', {
    staticClass: "ch"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor000"
    }
  }), _vm._v("Prologue")]), _vm._v(" "), _c('h2', {
    staticClass: "sub"
  }, [_vm._v("January 1800, Duxford, Cambridgeshire")]), _vm._v(" "), _c('p', {
    staticClass: "body-text-opening"
  }, [_c('span', {
    staticClass: "lic"
  }, [_vm._v("‘Y")]), _vm._v("our papa has passed away.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘What? I do not understand.’ Even as she spoke, the impact of the doctor’s words swept through Jane. It was as though they were a dark cloud, seeping through her ears to contaminate every part of her. ‘Passed away?’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The doctor looked pained. ‘I am very sorry, little one. I tried very hard to save Mr Bailey, but the fever was too strong.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Behind him, his assistant, a middle-aged woman, emerged from the bedchamber with a dish filled with blood.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('i', [_vm._v("They bled him, yet still he died? ")]), _vm._v("Her own internal words sank in. "), _c('i', [_vm._v("He is dead. Papa is dead.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘Impossible!’ Her voice sounded strange, as if it was not her own. ‘I want Mama!’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Before the doctor could stop her she dashed forward, then stopped abruptly in the doorway. This was her parents’ bedchamber—the place that had always been her haven, her refuge. When she was upset, or had a nightmare, they sometimes allowed her to share their bed. Snuggling up to Mama and Papa had always been her moment of perfect happiness—even though she had recently celebrated her eighth birthday and had a tiny chamber of her own.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Her eyes were drawn immediately to the bed. There he was, looking white and strange and still and most unlike himself. ‘Papa?’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘Oh, my darling Jane!’ Mama rose from a hard chair beside the bed. Her eyes were red with endless tears and lack of sleep. ‘He is gone. Papa is gone.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("They held each other, crying together for an eternity. The doctor quietly closed the door.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("In the days that followed Jane gradually understood that losing Papa had more implications than simply being the cause of untold grief. Without Papa’s earnings as clerk to Mr Simmons—the best lawyer in Duxford—they would no longer be able to stay in Rose Cottage, their little rented home.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Jane was old enough to understand a little of how things worked.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘But Mama, where shall we live? And how shall we get money for food?’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘Hush, child. We shall manage.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Yet Mama looked worried, as if she was not entirely sure just "), _c('i', [_vm._v("how")]), _vm._v(" they would manage.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Jane thought about it carefully. ‘What of Papa’s family? He spoke to me of my grandfather and told me they had become estranged. Could we not write to him? Perhaps—’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘Out of the question!’ Mama’s tone was sharp. ‘Your father’s family wanted nothing to do with him. That has not changed—in fact it is even less likely now Papa is gone. Your grandfather’s cruelty towards my Ned was implacable. There is no way back. Do not speak of it again!’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Jane gulped. ‘Yes, Mama.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Mama’s face softened. ‘When I met your papa I was a servant—and a very good one. I shall find us a situation and we will both work hard so we can be comfortable.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('i', [_vm._v("Without Papa?")]), _vm._v(" Jane thought. "), _c('i', [_vm._v("I shall never be comfortable again.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d8cbd3e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Prologue.vue
// module id = 78
// module chunks = 0